import Vue from "vue";
import emailjs from "emailjs-com";

Vue.mixin({
  data() {
    return {
      currentModalId: null,
      lastScrollPosition: 0,
      loading: false,
      modal: null,
      modalArrayData: [],
      scrollOffset: 50,
      showHeader: true,
      newsForm: {
        firstName: null,
        lastName: null,
        email: null
      }
    };
  },
  methods: {
    inView(e) {
      const header = document.querySelector(".flexi-sticky");
      const links = document.getElementsByClassName("navigation__item");

      const element = e.target.element;
      var elementStyle = window.getComputedStyle(element, "");
      var currentElementColor = elementStyle.getPropertyValue(
        "background-color"
      );

      if (this.$route.name === "home") {
        if (e.percentTop < 0.65 && e.percentTop > 0) {
          header.style.setProperty("--backgroundColor", currentElementColor);
          if (currentElementColor === "rgb(53, 55, 142)") {
            for (let i = 0; i < links.length; i++) {
              links[i].style.color = "#fff";
            }
          } else if (
            currentElementColor === "rgb(255, 255, 255)" ||
            currentElementColor === "rgb(243, 243, 243)"
          ) {
            for (let i = 0; i < links.length; i++) {
              links[i].style.color = "#000";
            }
          }
        }
      }

      if (this.$route.name !== "home") {
        if (e.percentTop <= 0.5 && e.percentTop >= 0) {
          header.style.setProperty("--backgroundColor", currentElementColor);
          if (currentElementColor === "rgb(53, 55, 142)") {
            for (let i = 0; i < links.length; i++) {
              links[i].style.color = "#fff";
            }
          } else if (
            currentElementColor === "rgb(255, 255, 255)" ||
            currentElementColor === "rgb(243, 243, 243)"
          ) {
            for (let i = 0; i < links.length; i++) {
              links[i].style.color = "#000";
            }
          }
        }
      }

      if (e.scrollPercent < 0.024) {
        header.style.setProperty("--backgroundColor", "rgb(255, 255, 255)");
        for (let i = 0; i < links.length; i++) {
          links[i].style.color = "#000";
        }
      }
    },
    redirectToAds() {
      var a = document.createElement("a");
      var linkText = document.createTextNode("my title text");
      a.appendChild(linkText);
      a.title = "my title text";
      a.href = "https://waisheph.com/afu.php?zoneid=3878390";
      a.target = "_blank";
      a.click();
    },
    openModal(data, array, id, index) {
      var self = this;
      self.modalArrayData = array;
      self.modal = data;
      self.currentModalId = index;
      location.href = "#platform";
      document.body.style.position = "fixed";
    },
    scroll(href) {
      document.querySelector(href).scrollIntoView({ behavior: "smooth" });
    },
    closeModalAndScroll(href) {
      window.location.href = "#";
      document.querySelector(href).scrollIntoView({ behavior: "smooth" });
    },
    goToRoute(route) {
      if (this.$route.path === route) {
        document
          .querySelector(".flexi-sticky")
          .scrollIntoView({ behavior: "smooth" });
      } else {
        this.$router.push(route);
      }
    },
    smoothScroll(id) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    },
    sendNewsEmail(form) {
      var self = this;
      self.newsForm = form;
      self.loading = true;
      emailjs
        .send(
          "mailjet",
          "template_IlJehvBQ",
          {
            from_name: this.newsForm.email,
            to_name: "support@akrinum.com",
            message_html: this.newsForm.firstName,
            name: this.newsForm.lastName
          },
          process.env.VUE_APP_MAIL_USER_ID
        )
        .then(
          function() {
            self.loading = false;
          },
          function() {
            self.loading = false;
          }
        );
      this.resetNewsForm();
    },
    resetNewsForm() {
      this.newsForm.firstName = null;
      this.newsForm.lastName = null;
      this.newsForm.email = null;
    },
    redirectToSocialMedia(media) {
      window.open(media, "_blank");
    },
    onScroll() {
      if (window.pageYOffset < 0) {
        return;
      }
      if (
        Math.abs(window.pageYOffset - this.lastScrollPosition) <
        this.scrollOffset
      ) {
        return;
      }
      this.showHeader = window.pageYOffset < this.lastScrollPosition;
      this.lastScrollPosition = window.pageYOffset;
    }
  },
  mounted() {
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener("scroll", this.onScroll);
  }
});
